// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-nav {
  z-index: 9999;
  opacity: 0.5;
  position: fixed;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: none;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease;
}

.sidebar-nav:hover {
  opacity: 1.0;
}

.arrow-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
}

.arrow-btn svg {
  fill: #007bff;
  width: 24px;
  height: 24px;
}

.arrow-btn:disabled svg {
  fill: #ccc;
}

.section-indicator {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}

@media screen and (min-width: 760px){
  .sidebar-nav{
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/SidebarNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".sidebar-nav {\r\n  z-index: 9999;\r\n  opacity: 0.5;\r\n  position: fixed;\r\n  left: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: none;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background-color: #f8f9fa;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.sidebar-nav:hover {\r\n  opacity: 1.0;\r\n}\r\n\r\n.arrow-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n}\r\n\r\n.arrow-btn svg {\r\n  fill: #007bff;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.arrow-btn:disabled svg {\r\n  fill: #ccc;\r\n}\r\n\r\n.section-indicator {\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  color: #333;\r\n}\r\n\r\n@media screen and (min-width: 760px){\r\n  .sidebar-nav{\r\n    display: flex;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
